import styled from "@emotion/styled";
import { OLD_BLUE } from "src/constants/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 24px;
`;

export const ButtonDropdownAnchor = styled.div`
  position: relative;
`;

export const FindSelectionLabel = styled.span`
  text-transform: capitalize;
`;

export const TagCloseButton = styled.button`
  background-color: transparent;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  cursor: pointer;

  &:hover {
    background-color: white;
  }
`;

export const ValueHighlight = styled.span`
  color: ${OLD_BLUE};
  font-weight: 700;
  text-transform: capitalize;
`;
